import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';
import { WidgetStrategyWithStreamByRequestUid } from 'widgets/WidgetRegistry';
import { VenueTypeCapsule } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/components/VenueTypeCapsule';

import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { VenueTypeCapsuleMyPortfolioCapsuleContent } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/components/VenueTypeCapsuleMyPortfolioCapsuleContent';
import { VenueAnalysisByOrderIdsOrSymbolStreamRequest } from 'widgets/venueAnalysis/api/VenueAnalysisByOrderIdsOrSymbolStreamRequest';
import VenueTypeCapsuleSettings from './components/settings/VenueTypeCapsuleSettings';

import { venueAnalysisStreamedDataSelectors } from 'widgets/venueAnalysis/store/stream/streamSlice';
import { venueTypeCapsuleDescription } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/components/description/venueTypeCapsuleDescription';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { venueAnalysisStreamConfig } from 'widgets/venueAnalysis/store/stream/stream-config';

const useMessagesInMyPortfolioCapsules = (symbol: string) =>
    venueAnalysisStreamedDataSelectors.useStreamedDataMessages(
        symbol,
        initialVenueAnalysisCapsuleConfigState
    );

export const venueTypeCapsuleStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<VenueAnalysisCapsuleConfigState> &
    WidgetStrategyWithStreamByRequestUid<VenueAnalysisByOrderIdsOrSymbolStreamRequest> =
    {
        title: 'Fills by Venue Type',
        supportedHosts: ['tile'],
        reactComponentType: VenueTypeCapsule,
        myPortfolioCapsuleContentReactComponentType:
            VenueTypeCapsuleMyPortfolioCapsuleContent,
        categories: [WidgetCategory.FILL_CAPSULES],
        description: venueTypeCapsuleDescription,
        initialConfigState: initialVenueAnalysisCapsuleConfigState,
        supportsMyPortfolioCapsule: true,
        supportsMyPortfolioCapsuleConfig: true,
        renderSettingsBody,
        managedStreamConfig: venueAnalysisStreamConfig,
        portfolioSelectionRequirements:
            PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
        portfolioSelectionRequirementsWithoutOrdersStream:
            PortfolioSelectionRequirements.SingleSymbol,
        useMessagesInMyPortfolioCapsules,
        wideTitle: true,
    };

function renderSettingsBody(
    config: VenueAnalysisCapsuleConfigState,
    onChange: (configDelta: Partial<VenueAnalysisCapsuleConfigState>) => void
) {
    return <VenueTypeCapsuleSettings config={config} onChange={onChange} />;
}
